var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[(_vm.$slots['menu-left'])?_c('v-col',{staticClass:"col-sm-4 col-md-3"},[_vm._t("menu-left")],2):_vm._e(),_c('v-col',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }